module.exports = __webpack_public_path__ + "static/media/sass.9b47dd66.svg";